import { render, staticRenderFns } from "./TreeStructureItem.vue?vue&type=template&id=685d1e44&scoped=true"
import script from "./TreeStructureItem.vue?vue&type=script&lang=js"
export * from "./TreeStructureItem.vue?vue&type=script&lang=js"
import style0 from "./TreeStructureItem.vue?vue&type=style&index=0&id=685d1e44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685d1e44",
  null
  
)

export default component.exports